import React, { createContext, useEffect, useState } from 'react'
import Head from './components/head'
import Footer from './components/footer'
import { Outlet } from 'react-router-dom'
import api from './uitil/api'
export const CountContext = createContext()
export default function App () {
  //下载总榜
  const [winHot, setWinhot] = useState([])
  const [macHot, setMachot] = useState([])
  const [gameHot, setGamehot] = useState([])
  //请求排行榜数据
  const charts = async (chartsApi) => {
    await api.get(`/download/sumType/${chartsApi}`).then((data) => {
      if (chartsApi === '11') {
        setWinhot(data)
      } else if (chartsApi === '12') {
        setMachot(data)
      } else if (chartsApi === '13') {
        setGamehot(data)
      }
    })
  }
  //初始化调用一次
  useEffect(() => {
    charts('11')
    charts('12')
    charts('13')
  }, [])
  return (
    <div style={{ backgroundColor: "white" }}>
      <CountContext.Provider value={{ winHot, macHot, gameHot }}>
        <Head />
        <Outlet />
        <Footer />
      </CountContext.Provider>
    </div>
  )
}
